export default __webpack_public_path__ + "0bb1fc3990edd0bd1ddee4433e4cc032.svg";